<router-outlet>
</router-outlet>

<ngx-loading [config]="{fullScreenBackdrop : true}" [show]="loading"></ngx-loading>

